module.exports = "../dist/img/upper-banner-29.ee33.jpg";